// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__WZdzf","content":"styles_content__4Jutx","title":"styles_title__Y10A1","back":"styles_back__K4YmK"};